// Plan ▸ Continuity: findings to check against the story data, each openable and addable to the margin.
export { ContinuityPage as component } from '../../views/story/ContinuityPage.tsx';
export { StoryColumn as column } from '../../views/story/StoryColumn.tsx';
export const room = 'plan';
export const page = 'continuity';
export const title = 'Continuity';
export const help = 'continuity';
export const columnTitle = 'People';
